import { render, staticRenderFns } from "./qrZoom.popup-chunk.vue?vue&type=template&id=84274fd8"
import script from "./qrZoom.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./qrZoom.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports